import {React, useEffect }from "react";
import { useNavigate } from "react-router-dom";
import { articlesData } from "./articledata";
import "../../styles/articles.css";

function Articles() {
  const navigate = useNavigate();

  const articles = [
    {
      id: "understanding-motivation-goal-management",
      title: "Understanding Motivation and Goal Management",
      description: "Learn more about motivation and how it can help you achieve your goals.",
      image: articlesData["understanding-motivation-goal-management"].image,
      date: "April 8, 2026",
      readTime: "5 min",
      category: "Optimization",
    },


  /*   
    {
      id: "ai-a-tool-that-turn-back",
      title: "Artifical intelligence a tool that turn back time?",
      description: "This is another article example",
      image: articlesData["understanding-motivation-goal-management"].image,
      date: "April 10, 2026",
      readTime: "3 min",
      category: "Tech",
    },
   
    {
      id: "ai-a-tool-that-turn-back-time",
      title: "Artifical intelligence a tool that turn back time?",
      description: "This is another article example",
      image: articlesData["understanding-motivation-goal-management"].image,
      date: "April 10, 2026",
      readTime: "3 min",
      category: "Tech",
    },
    */
  ];

  return (
    <div className="articles">
      {articles.map((article) => (
        <div
          key={article.id}
          className="articles-container"
          onClick={() => navigate(`/blog/${article.id}`)}
          style={{ cursor: "pointer" }}
        >
          <div className="article-display">
            <img src={article.image} className="articles-img" alt={article.title} />

            <div className="article-info">
              <h1>{article.title}</h1>
              <div className="article-details">
                <p>
                  {article.category} · {article.readTime} · {article.date}
                </p>
              </div>
              <p>{article.description}</p>
            </div>
          </div>

          <div className="horizontal-line-article" />
        </div>
      ))}
    </div>
  );
}

export default Articles;